import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import { Oferent } from 'app/model/oferent';
import { of } from 'rxjs/observable/of';
import { AuthService } from 'app/services/auth.service';
import { WojewodztwaService, EnumWojewodztwo } from 'app/services/wojewodztwa.service';

@Injectable()
export class OfferService {

  OFFERS: Array<Oferent> = [];

  constructor(public af: AngularFireDatabase,
    private authService: AuthService,
    private wojewodztwaService: WojewodztwaService) {
    this.reloadFromDb();
  }

  reloadFromDb(): void {
    this.af.list('/dostawcy').snapshotChanges().subscribe(action => {
      this.OFFERS = [];
      action.forEach(a => {
        const val = a.payload.val();
        const oferent = new Oferent();
        oferent.id = a.payload.key;

        oferent.nazwa = val.nazwa;
        oferent.adres = val.adres;
        oferent.email = val.email;
        oferent.tel = val.tel;
        oferent.www = val.www;
        oferent.info = val.info;
        oferent.confirmed = val.confirmed ? true : false;

        oferent.wojewodztwa[0] = val.w0 ? val.w0 : false;
        oferent.wojewodztwa[1] = val.w1 ? val.w1 : false;
        oferent.wojewodztwa[2] = val.w2 ? val.w2 : false;
        oferent.wojewodztwa[3] = val.w3 ? val.w3 : false;


        this.OFFERS.push(oferent);
      });
    });
  }

  getOffers() {
    return this.OFFERS.filter(ofr => (this.showOfferToAll(ofr)));
  }

  getOffers4CurrentLocation() {
    return this.getOffers().filter(ofr => (this.isOfferLocalForMe(ofr)));
  }

  isOfferLocalForMe(ofr: Oferent): boolean {
    let bOk: boolean;
    bOk = ofr.wojewodztwa[0] && this.wojewodztwaService.checkWojewodztwo(EnumWojewodztwo.lub);
    bOk = bOk || (ofr.wojewodztwa[1] && this.wojewodztwaService.checkWojewodztwo(EnumWojewodztwo.maz));
    bOk =  bOk || (ofr.wojewodztwa[2] && this.wojewodztwaService.checkWojewodztwo(EnumWojewodztwo.podk));
    bOk =  bOk || (ofr.wojewodztwa[3] && this.wojewodztwaService.checkWojewodztwo(EnumWojewodztwo.swiet));
    return bOk;
  }

  showOfferToAll(ofr: Oferent): boolean {
    const a = this.authService.isAdmin();
    const s = this.authService.isSuperUser();
    return a || s || ofr.confirmed;
  }

  saveNew(oferent: Oferent): firebase.database.ThenableReference {
    const data = {
      nazwa: oferent.nazwa,
      adres: oferent.adres,
      email: oferent.email,
      tel: oferent.tel,
      www: oferent.www,
      info: oferent.info,
      confirmed: oferent.confirmed,
      w0: oferent.wojewodztwa[0],
      w1: oferent.wojewodztwa[1],
      w2: oferent.wojewodztwa[2],
      w3: oferent.wojewodztwa[3]
    };

    return this.af.list('/dostawcy/').push(data);
  }


  save(oferent: Oferent) {
    const data = {
      nazwa: oferent.nazwa,
      adres: oferent.adres,
      email: oferent.email,
      tel: oferent.tel,
      www: oferent.www,
      info: oferent.info,
      confirmed: oferent.confirmed,
      w0: oferent.wojewodztwa[0],
      w1: oferent.wojewodztwa[1],
      w2: oferent.wojewodztwa[2],
      w3: oferent.wojewodztwa[3]
    };

    if (!oferent.id) {
      this.af.list('/dostawcy/').push(data);
    } else {
      this.af.object('/dostawcy/' + oferent.id).update(data);
    }
  }

  delete(id: string): void {
    const toDelete: Array<string> = [];
    this.af.object('/dostawcy/' + id).remove()
      .then(aa => {
        console.log('Deleted');
        this.af.list('/ceny_montazu').snapshotChanges().subscribe(action => {
          action.forEach(a => {
            const key = a.payload.key;
            const val = a.payload.val();
            if (val.dostawca_id === id) {
              // delete
              toDelete.push(key);
            }
          });
          for (const strId of toDelete) {
            this.af.object('/ceny_montazu/' + strId).remove()
          }
        });
      });
  }

  confirm(id: string, val: boolean): void {
    const path = '/dostawcy/' + id + '/confirmed';
    this.af.object(path).set(val)
      .then(aa => {
        const subs = this.af.list('/ceny_montazu').snapshotChanges();
        const usub = subs.subscribe(action => {
          action.forEach(a => {
            const key = a.payload.key;
            const vall = a.payload.val();
            if (vall.dostawca_id === id) {
              this.af.object('/ceny_montazu/' + key + '/confirmed').set(val);
            }
          });
          usub.unsubscribe();
        });
      });
  }


  getOfr(id: string): Oferent {
    for (const ofr of this.OFFERS) {
      if (ofr.id === id) {
        return ofr;
      }
    }
    return null;
  }

  getOffer(id: string): Observable<Oferent> {
    return of(this.OFFERS.find(oferent => oferent.id === id));
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/offer.service.ts